var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "conversation-list",
    _vm._b(
      {
        ref: "list",
        attrs: { "add-to-group-props": _vm.addToGroupProps },
        on: { change: _vm.onChange },
      },
      "conversation-list",
      { filterList: _vm.filterList, delay: _vm.delay },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }